<div *comSpinner="mfaLoading; color: 'primary'; diameter: 35">
  <form [formGroup]="mfaGroup" (ngSubmit)="confirmAuthCode(mfaGroup.value)">
    @if (!this.user?.mfaConfigured && this.mfa) {
      <div class="mfa__instructions">
        <div>
          Using an authenticator application on a smart phone<br />or tablet, scan this QR code:
          <div class="mfa__qrcode--image">
            <qrcode [qrdata]="mfa.qrCodeString" [width]="qrWidth" [errorCorrectionLevel]="qrErrorCorrectionLevel"></qrcode>
          </div>
          <b>Alternatively, enter this key:</b>
          <br /><span class="mfa__qrcode--key">{{ mfa.authenticatorKey }}</span>
        </div>
        <div class="mfa__instructions">
          <div>Now enter the 6 digit code from the<br />authenticator application:</div>
          <div class="mfa__buttons">
            <mat-form-field class="mfa__form-field">
              <mat-label>Enter 6 digit authentication code</mat-label>
              <input matInput id="authcode" [formControl]="authCode" />
              <mat-error>Required</mat-error>
            </mat-form-field>
            <p class="mfa__link">
              <span (click)="cancelLogIn()" class="mfa__link--text">Cancel log In</span>
            </p>
            <br />
            <button mat-raised-button type="submit" class="mfa__buttons--confirm">Confirm</button>
          </div>
          @if (user.mfaOptional) {
            <div class="mfa__link">
              <a (click)="skipMfaSetup()" class="mfa__link--text">I do not wish to setup MFA at this time</a>
            </div>
          }
        </div>
      </div>
    } @else if (this.user?.mfaConfigured && this.mfa) {
      <div class="mfa__instructions">
        <div>Enter the 6 digit code from your authenticator application:</div>
        <div class="mfa__buttons">
          <mat-form-field class="mfa__form-field">
            <mat-label>Enter 6 digit authentication code</mat-label>
            <input matInput id="authcode" [formControl]="authCode" />
            <mat-error>Required</mat-error>
          </mat-form-field>
          <p class="mfa__link">
            <span (click)="cancelLogIn()" class="mfa__link--text">Cancel log In</span>
          </p>
          <br />

          <button mat-raised-button type="submit" class="mfa__buttons--confirm">Confirm</button>
        </div>
      </div>
    }
  </form>
</div>
